'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Button, Icon } from '~/components/primitives';
import { Popover, PopoverContent, PopoverTrigger } from '~/components/primitives';
import { cn } from '~/utils';
import { Calendar } from './Calendar';
import type { Mode as DaySelectionMode } from 'react-day-picker';
import { DateTime } from './DateTime';
export const DatePicker: React.FC<{
  value: Date | undefined | string | null;
  className?: string;
  placeholder?: string;
  required?: boolean;
  prefix?: React.ReactNode;
  /** @default 'single' */
  mode?: DaySelectionMode;
  /** @default false */
  readOnly?: boolean;
  /** @default false */
  showIcon?: boolean;
  /** Disable dates before this date */
  fromDate?: Date;
  /** Disable dates after this date */
  toDate?: Date;
  onChange?: (value?: Date | null) => void;
  'data-testid'?: string;
}> = props => {
  const $ = _c(39);
  const [open, setOpen] = React.useState(false);
  let t0;
  bb0: {
    if (props.value instanceof Date) {
      t0 = props.value;
      break bb0;
    }
    if (typeof props.value === "string" && props.value.length > 0) {
      let t1;
      if ($[0] !== props.value) {
        t1 = new Date(props.value);
        $[0] = props.value;
        $[1] = t1;
      } else {
        t1 = $[1];
      }
      t0 = t1;
      break bb0;
    }
    t0 = null;
  }
  const selectedDate = t0;
  const t1 = props.readOnly ?? false;
  const t2 = !selectedDate && "text-muted-foreground";
  let t3;
  if ($[2] !== props.className || $[3] !== t2) {
    t3 = cn("bg-white font-normal", t2, props.className);
    $[2] = props.className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = props["data-testid"];
  let t5;
  if ($[5] !== props.prefix) {
    t5 = typeof props.prefix === "string" && props.prefix.length > 0 && <span className="mr-1 text-sm text-blue-500">{props.prefix}</span>;
    $[5] = props.prefix;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props.placeholder || $[8] !== selectedDate) {
    t6 = selectedDate ? <DateTime format="date" date={selectedDate} /> : <span className="text-blue-500">{props.placeholder ?? "__/__/____"}</span>;
    $[7] = props.placeholder;
    $[8] = selectedDate;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== props.showIcon) {
    t7 = (props.showIcon ?? true) && <Icon name="calendar" size="sm" className="ml-auto text-secondary" />;
    $[10] = props.showIcon;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <Button variant="outline" size="lg" className={t3} data-testid={t4}>{t5}{t6}{t7}</Button>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t8) {
    t9 = <PopoverTrigger asChild={true} disabled={t1}>{t8}</PopoverTrigger>;
    $[18] = t1;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = selectedDate || undefined;
  let t11;
  if ($[21] !== props) {
    t11 = date => {
      props.onChange?.(date);
      setOpen(false);
    };
    $[21] = props;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = props.required || undefined;
  let t13;
  if ($[23] !== props.toDate) {
    t13 = props.toDate ?? new Date(new Date().getFullYear() + 5, 11);
    $[23] = props.toDate;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== props.fromDate || $[26] !== props.toDate) {
    t14 = props.fromDate !== undefined || props.toDate !== undefined ? date_0 => props.fromDate !== undefined && date_0 < props.fromDate || props.toDate !== undefined && date_0 > props.toDate : undefined;
    $[25] = props.fromDate;
    $[26] = props.toDate;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== props.fromDate || $[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t13 || $[33] !== t14) {
    t15 = <PopoverContent className="w-auto p-0"><Calendar mode="single" captionLayout="dropdown" selected={t10} onSelect={t11} initialFocus={true} required={t12} startMonth={props.fromDate} endMonth={t13} disabled={t14} /></PopoverContent>;
    $[28] = props.fromDate;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== open || $[36] !== t15 || $[37] !== t9) {
    t16 = <Popover open={open} onOpenChange={setOpen}>{t9}{t15}</Popover>;
    $[35] = open;
    $[36] = t15;
    $[37] = t9;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};